import React, { useEffect, useState } from 'react';
import ProductGrid from '../components/ProductGrid';
import { getProducts } from '../api/apiendpoint';
import { useCart } from '../context/CartContext';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 10;

  const { addToCart } = useCart();

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const loadProducts = async () => {
      const data = await getProducts();
      const formatted = data.map(p => ({
        id: p.id,
        name: p.product_name || 'Unnamed Product',
        image: p.images.length > 0
          ? `https://mysite-dtzs.onrender.com${p.images[0].product_img}`
          : 'https://via.placeholder.com/300x250?text=No+Image',
        originalPrice: parseFloat(p.product_price) || 0,
        discountedPrice: parseFloat(p.product_price_discount) || 0,
        price: parseFloat(p.product_price_discount) || 0,
        description: p.product_discription || 'No description available.',
        category: p.category?.name_category || 'Uncategorized',
      }));
      setProducts(shuffleArray(formatted));
    };

    loadProducts();
  }, []);

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination calculations
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    scrollToTop(); // Add scroll to top
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
      scrollToTop(); // Add scroll to top
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
      scrollToTop(); // Add scroll to top
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${currentPage === i ? 'btn-dark' : 'btn-outline-dark'}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const bannerImage = 'https://cdn.pixabay.com/photo/2014/04/09/15/25/fruits-320136_1280.jpg';

  return (
    <>
      {/* Banner Section */}
      <div className="container-fluid p-0">
        <div
          className="d-flex flex-column align-items-center justify-content-center text-white text-center"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '300px',
            padding: '1rem',
          }}
        >
          <h1 className="display-4 font-weight-bold text-shadow mb-3">All Products</h1>
          {/* <input
            type="text"
            placeholder="Search products..."
            className="form-control w-50"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            style={{ maxWidth: '400px' }}
          /> */}
        </div>
      </div>

      {/* Product Section */}
      <div className="container py-5">
        <ProductGrid products={currentProducts} addToCart={addToCart} />

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4 flex-wrap">
            <button
              className="btn btn-sm btn-outline-dark mx-1"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            {renderPageNumbers()}
            <button
              className="btn btn-sm btn-outline-dark mx-1"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Products;